// https://github.com/microsoft/applicationinsights-react-js/blob/main/applicationinsights-react-js/src/AppInsightsErrorBoundary.tsx

import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {ReactPlugin} from '@microsoft/applicationinsights-react-js';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { createBrowserHistory } from "history";

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();
const clickPluginInstance: ClickAnalyticsPlugin = new ClickAnalyticsPlugin();

const appInsightService = new ApplicationInsights({
    config: {
        //instrumentationKey: process.env.REACT_APP_APPINSIGHT_INSTRUMENTATION_KEY,
        connectionString: process.env.REACT_APP_APPINSIGHT_INSTRUMENTATION_CONN_STRING,
        extensions: [reactPlugin, clickPluginInstance],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory },
            [clickPluginInstance.identifier]: {
                autoCapture: true,
                dataTags: { useDefaultContentNameOrId: true }
            },
        },
        maxBatchInterval: 10,
        enableCorsCorrelation: true,
        enableAutoRouteTracking: true,      // If seeing duplicate entries in AppInsights trackPageView() is probably logging what this tracks already.
        // The following settings might be nice to have too.
        autoTrackPageVisitTime: true,
        //enableRequestHeaderTracking: true,
        //enableResponseHeaderTracking: true,
    },
});

appInsightService.loadAppInsights();
export { reactPlugin, appInsightService };
